/* eslint-disable no-unused-vars */
import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { Main } from './bots.main';
import Snackbar from '@mui/material/Snackbar';


const Page = ({ backendEndpoint, rendererEndpoint, extension, user }) => {

    const activeBackend = async () => {
        return await fetch(`${backendEndpoint}/api/`);
    };
    const validateCustomerId = async (customerId) => {
        return await fetch(`${backendEndpoint}/api/verify/${customerId}`);
    };
    const getCustomerId = () => {
        const query = new URLSearchParams(window.location.search);
        let v = query.get('customerId') || query.get('id') || 'none'
        return v
    }

    const [customerId, setCustomerId] = useState(window?.xprops?.customerId || getCustomerId());
    const [asephaSettings, setAsephaSettings] = useState(window?.xprops?.asephaSettings);
    const [showSearchBar, setShowSearchBar] = useState(window.xprops?.asephaSearchBar?.show ?? true);
    const [query, setQuery] = useState('');
    const [disableBot, setDisableBot] = useState(false);
    const [botError, setBotError] = useState({ message: '', open: false })

    activeBackend().then((res) => {
        if (res.status != 200) {
            setBotError({ open: true, message: "Intelligent Search is currently unavailable. Please try again later." });
            setDisableBot(true);
        }
    }).catch(err => {
        setBotError({ open: true, message: "Intelligent Search is currently unavailable. Please try again later." });
        setDisableBot(true)
    })

    useEffect(() => {
        if (customerId) {
            setCustomerId(customerId);
            validateCustomerId(customerId).then((res) => {
                if (res.status != 200) {
                    setBotError({ open: true, message: "Intelligent Search is unavailable to unauthorized users" });
                    setDisableBot(true);
                }
            }).catch(err => {
                setBotError({ open: true, message: "Intelligent Search is unavailable to unauthorized users" });
                setDisableBot(true)
            })

            if (window?.xprops?.asephaSettings) setAsephaSettings(window.xprops.asephaSettings)
            if (window.xprops?.asephaQuery) {
                setQuery(window.xprops.asephaQuery);
            }

        } else {
            // console.log('customerId is missing');
        }
    }, [customerId, showSearchBar]);

    return (
        <Box component="main"
            sx={{ flexGrow: 1, py: 0, px: 0, mx: 0 }}>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={botError?.open}
                message={botError.message}
            />
            <Container sx={{ py: 0, px: 0.5 }}>
                <Grid container
                    spacing={{ xs: 4, lg: 4 }}>
                    <Grid item sx={{ px: 0 }}
                        xs={12}
                        lg={12}>
                        <Stack sx={{ width: '100%', color: 'grey.500' }}
                            spacing={2}>
                            <Main
                                user={user}
                                query={query}
                                extension={extension}
                                rendererEndpoint={rendererEndpoint}
                                backendEndpoint={backendEndpoint}
                                showSearchBar={showSearchBar}
                                asephaSettings={asephaSettings}
                                disableBot={disableBot}
                                customerId={customerId} />
                        </Stack>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default Page;